<template>
  <div>
    <div
      class="OrderWrap"
      style="
        padding: 20px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
        float: left;
        width: 100%;
        min-width:1200px;
        box-sizing: border-box;
      "
    >
      <p class="comeback" @click="comeback()">
        <span class="el-icon-arrow-left"></span>
        <span>返回</span>
      </p>
      <div class="center_wrap">
        <div class="wrap_l">
          <el-collapse v-model="show1" class="leftItem">
            <!-- 地址信息 -->
            <el-collapse-item name="1">
              <template slot="title">
                <div class="titleSlot">
                  <div style="float: left; margin-right: 16px">
                    <img
                      src="../../../assets/images/billdz.png"
                      alt="地址信息"
                    />
                  </div>
                  <div class="SlotTit">地址信息</div>
                </div>
              </template>
              <LocaText
                @getFBATrans="getFBATrans"
                @GettodoorMoney="GettodoorMoney"
                :LocahouseDTO="LocahouseDTO"
                @getcountLIst_S="getcountLIst_S"
                @getTime="getTime"
              ></LocaText>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="show2" class="leftItem">
            <!-- 地址信息 -->
            <el-collapse-item name="1">
              <template slot="title">
                <div class="titleSlot">
                  <div style="float: left; margin-right: 16px">
                    <img src="../../../assets/thicon.png" alt="货物信息" />
                  </div>
                  <div class="SlotTit">货物信息</div>
                </div>
              </template>
              <Boxdata
                ref="ruleform"
                @getFBATrans="getFBATrans"
                @getTimoney="getTimoney"
                @getBoxformLIst="getBoxformLIst"
                :LocahouseDTO="LocahouseDTO"
                @GetformType="GetformType"
              ></Boxdata>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="show3" class="leftItem">
            <el-collapse-item name="1">
              <template slot="title">
                <div style="padding: 0 29px">
                  <div style="float: left; margin-right: 16px">
                    <img src="../../../assets/style.png" alt="增值服务" />
                  </div>
                  <div
                    style="
                      float: left;
                      font-size: 18px;
                      font-weight: bold;
                      color: black;
                    "
                  >
                    增值服务
                  </div>
                </div>
              </template>
              <div
                class="Item_list"
                v-for="(item, index) in formData.feeItemDTOS"
                :key="index"
              >
                <div style="width: 100%">
                  <el-checkbox
                    v-model="item.checked"
                    @change="Changehandle(item)"
                    >{{ item.feeName }}</el-checkbox
                  >
                  <el-tooltip
                    v-show="item.feeDescription"
                    class="item"
                    effect="dark"
                    :content="item.feeDescription"
                    placement="top-start"
                  >
                    <span
                      style="font-size: 14px; color: #f9a123"
                      class="el-icon-question"
                    ></span>
                  </el-tooltip>
                </div>
                <div
                  class="LR_center"
                  style="width: 100%; float: left"
                  v-show="item.checked"
                >
                  <div
                    class="count_center"
                    style="padding: 25px 25px 0 25px; box-sizing: border-box"
                  >
                    <span style="float: left">{{ item.priceDesc }}</span>
                    <div
                      style="float: left; margin-left: 15px"
                      v-show="
                        item.feeCode != 'FB003' && item.feeCode != 'FB019'
                      "
                    >
                      <el-input-number
                        size="mini"
                        v-model="item.num"
                        @change="Changehandle(item)"
                        :min="1"
                        :max="9999"
                      ></el-input-number>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.remark && item.checked"
                  style="float: right; color: #ccc; padding-right: 25px"
                >
                  *{{ item.remark }}
                </div>
              </div>
              <div
                v-show="formData.feeItemDTOS.length == 0"
                style="padding: 20px"
              >
                <el-alert
                  :closable="false"
                  title="该线路暂无增值服务"
                  type="warning"
                  description="该线路暂无增值服务"
                  show-icon
                >
                </el-alert>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 物流 -->
        <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
          <RightWrap
            :logisticsProductOrderDTO="logisticsProductOrderDTO"
            :boxList="ruleform.formLIst"
            :THFdata="THFdata"
            :FBATransmoney="FBATransmoney"
            :calFBAFeeIDTOS="calFBAFeeIDTOS"
          ></RightWrap>
          <div class="Item_Right animate__animated animate__bounceInRight">
            <div style="width: 100%; margin-top: 56px; float: left">
              <!-- <div style="width: 100%">
                <el-button style="width: 100%" @click="comeback()"
                  >上一步</el-button
                >
              </div> -->
              <!--  margin-top: 10px -->
              <div style="width: 100%;">
                <el-button
                  style="width: 100%; background: #FF4D01; color: #ffffff"
                  @click="pathToNext('ruleform')"
                  >确认修改订单</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import RightWrap from "./FBAChangedata/RightWrap.vue";
import LocaText from "./FBAChangedata/LocaText.vue";
import Boxdata from "./FBAChangedata/Boxdata.vue";
export default {
  components: {
    RightWrap,
    LocaText,
    Boxdata,
  },
  data() {
    return {
      THFdata: {
        checked: null,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: "",
        maxKilometer: "",
      },
      calFBAFeeIDTOS: {
        //增值服务计算
        amount: 0,
        feeDTOList: [],
      },
      logisticsProductOrderDTO: {},
      formData: {
        //增值服务展示
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      todoorTime: "",
      inwarehousetime: "",
      LocahouseDTO: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      show1: ["1"],
      show2: ["1"],
      show3: ["1"],
      FBATransmoney: {
        //运输费
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
        chargeWeight: "",
      },
      ruleform: {
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            goodsDTOList: [],
          },
        ],
      },
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      countLIst_T: {},
      billType: false,
      fromType: null,
      towarehouseid: "",
    };
  },
  watch: {},
  methods: {
    GetformType(Sondata) {
      this.fromType = Sondata;
    },
    pathToNext() {
      console.log("this.countLIst_S", this.countLIst_S);
      let PathCBM = 0;
      let fromArr = this.ruleform.formLIst;
      this.$refs["ruleform"].Changehandle();
      if (this.fromType) {
        fromArr.forEach((item, index) => {
          item.cbm = (item.length * item.width * item.height) / 1000000;
          PathCBM += parseFloat(+item.cbm);
        });
        if (
          this.billType &&
          this.LocahouseDTO.recwarehouseDTO.countryCode == "SA"
        ) {
          let newArray = JSON.parse(JSON.stringify(this.ruleform.formLIst));
          newArray.forEach((item, index) => {
            item.fbxBoxNo = item.fbxBoxNo.substr(0, 12);
          });
          for (var i = 0; i < newArray.length - 1; i++) {
            for (var j = i + 1; j < newArray.length; j++) {
              if (newArray[i].fbxBoxNo === newArray[j].fbxBoxNo) {
                if (newArray[i].shopName !== newArray[j].shopName)
                  return this.$message({
                    message: this.$createElement("p", null, [
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `第`
                      ),
                      this.$createElement(
                        "i",
                        { style: "color: #E6A23C" },
                        `${i + 1}`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `箱`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `和`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `第`
                      ),
                      this.$createElement(
                        "i",
                        { style: "color: #E6A23C" },
                        `${j + 1}`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `箱PO号相同，请填写相同的`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #F56C6C" },
                        "<商铺号>"
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #F56C6C" },
                        "<货件追踪号>"
                      ),
                    ]),
                  });
                if (newArray[i].poTrackingNo !== newArray[j].poTrackingNo)
                  return this.$message({
                    message: this.$createElement("p", null, [
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `第`
                      ),
                      this.$createElement(
                        "i",
                        { style: "color: #E6A23C" },
                        `${i + 1}`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `箱`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `和`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `第`
                      ),
                      this.$createElement(
                        "i",
                        { style: "color: #E6A23C" },
                        `${j + 1}`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #909399" },
                        `箱PO号相同，请填写相同的`
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #F56C6C" },
                        "<商铺号>"
                      ),
                      this.$createElement(
                        "span",
                        { style: "color: #F56C6C" },
                        "<货件追踪号>"
                      ),
                    ]),
                  });
              }
            }
          }
        }

        if (!this.countLIst_S.name) return this.$message("请选择发货联系人");
        if (!this.countLIst_S.tel) return this.$message("请输入发货人联系电话");
        if (this.THFdata.checked) {
          //如果勾选了提货
          if (!this.countLIst_T) return this.$message("请选择上门提货地址");
          if (this.todoorTime == null)
            return this.$message("请选择上门提货时间");
          this.onToNext();
        } else {
          //送货到仓
          if (!this.inwarehousetime) return this.$message("请选择送仓日期");
          this.onToNext();
        }
      } else {
        flag = false;
        return false;
      }
    },
    onToNext() {
      //提交订单
      if (this.FBATransmoney.amount == 0)
        return this.$message({ message: "计费过大不允许下单", type: "error" });
      const loading = this.$loading({
        lock: true,
        text: "下单中请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      let deliveryFbxAddressDTO = {
        getgoodsname: this.countLIst_T ? this.countLIst_T.name : "",
        getgoodstel: this.countLIst_T ? this.countLIst_T.tel : "",
        getgoodsprovince: this.countLIst_T ? this.countLIst_T.parvince : "",
        getgoodscity: this.countLIst_T ? this.countLIst_T.city : "",
        getgoodsarea: this.countLIst_T ? this.countLIst_T.area : "",
        getgoodsaddress: this.countLIst_T ? this.countLIst_T.address : "",
        getremarks: this.getgoodsremarks, //提货备注
      };
      let recwarehouseDTO = {
        recgoodscity: this.toFABck.city,
        recgoodscountry: this.toFABck.country,
        recremarks: this.recgoodremarks,
        recwarehouseaddress: this.toFABck.address,
        recwarehousecode: this.toFABck.namec,
      };
      let params = {
        orderId: this.LocahouseDTO.orderId,
        innos: this.LocahouseDTO.innos,
        busFbxjobsBeforeBoxDTOList: this.ruleform.formLIst,
        customerid: this.LocahouseDTO.customerid, //客户id
        delgoodsname: this.countLIst_S ? this.countLIst_S.name : "",
        delgoodstel: this.countLIst_S ? this.countLIst_S.tel : "",
        deliveryFbxAddressDTO: deliveryFbxAddressDTO,
        delremarks: "",
        finaArapFbxBeforeDTOList: that.formData.feeItemDTOS, //增值服务
        finaArapFbxBeforeTHFDTO: this.THFdata,
        finaArapFbxBeforeYSFDTO: this.FBATransmoney, //运输费
        fromCityId: this.LocahouseDTO.fromCityId, //起运城市id
        inwarehouseTime: this.inwarehousetime,
        isgetgoodstodoor: this.THFdata.checked,
        productPriceHeaderId: this.LocahouseDTO.productPriceHeaderId,
        recwarehouseDTO: recwarehouseDTO,
        remarks: "",
        saleid: this.LocahouseDTO.salesid,
        source: "WEB",
        todoordate: this.todoorTime,
        towarehouseid: this.toFABck.id,
        transportTypeCode: this.LocahouseDTO.transportTypeCode,
      };
      this.axios
        .post(`/busFbx/createFbxjobsBefore`, params)
        .then((res) => {
          // console.log('下单: ', res);
          if (res.data.code == "200") {
            // console.log(res.data.data.innos);
            loading.close();
            this.$router.push({
              name: "FBAheader",
            });
          } else {
            loading.close();
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getTime(timeData) {
      //获取提货和送仓日期
      console.log("timeData: ", timeData);
      if (timeData) {
        this.todoorTime = timeData.todoorTime;
        this.inwarehousetime = timeData.inwarehousetime;
      }
    },
    getcountLIst_S(countLIst_S) {
      console.log("countLIst_S: ", countLIst_S);
      this.countLIst_S = countLIst_S;
    },
    getFBATrans(Sondata) {
      console.log("Sondata==",Sondata)
      //   获取运输费
      this.ruleform.formLIst = Sondata;
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        boxDTOS.push(goodItem);
      });

      let params = {
        feeCode: "QBHYF",
        pollandId: this.LocahouseDTO.fromCityId, //起运地id,
        podlandId: this.LocahouseDTO.towarehouseid, //目的地仓库
        customerId: this.LocahouseDTO.customerid, //客户id
        boxDTOS: boxDTOS,
        transportTypeCode: this.LocahouseDTO.transportTypeCode,
        productPriceHeaderId: this.LocahouseDTO.productPriceHeaderId,
        isgetgoodstodoor: this.THFdata.checked,
      };
      this.axios
        .post(`/FBAfee/getFBATransportFee`, params)
        .then((res) => {
          // console.log("运输费", res);
          if (res.data.code == "200") {
            that.FBATransmoney.price = res.data.data.price;
            that.FBATransmoney.currency = res.data.data.currency;
            that.FBATransmoney.cnyprice = res.data.data.price;
            that.FBATransmoney.piece = 1;
            that.FBATransmoney.amount = res.data.data.amount;
            that.FBATransmoney.cnyamount = res.data.data.cnyamount;
            that.FBATransmoney.goodsTypeFeeDTOS =
              res.data.data.goodsTypeFeeDTOS;
            that.FBATransmoney.chargeWeight = res.data.data.chargeWeight;
          } else {
            that.FBATransmoney.cnyamount = 0;
            that.FBATransmoney.amount = 0;
            that.FBATransmoney.price = "";
            that.FBATransmoney.currency = "";
            that.FBATransmoney.cnyprice = "";
            that.FBATransmoney.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => {});
    },
    GettodoorMoney(countLIst_T) {
      if (countLIst_T) {
        this.countLIst_T = countLIst_T;
        this.getTimoney();
      }
    },
    getTimoney(Sondata) {
      //获取提货费
      if (Sondata) {
        this.ruleform.formLIst = Sondata;
      }
      let that = this;
      let weight = 0,
        cbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        item.cbm = (item.length * item.width * item.height) / 1000000;
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      let params = {};

      params = {
        province: this.countLIst_T ? this.countLIst_T.parvince : "", //省 name
        city: this.countLIst_T ? this.countLIst_T.city : "", //市 name
        area: this.countLIst_T ? this.countLIst_T.area : "", //区 name
        customerId: this.LocahouseDTO.customerid, //客户id
        feeCode: "THF",
        weight: weight,
        cbm: cbm,
        cityId: this.LocahouseDTO.fromCityId,
      };
      this.axios
        .post(`/FBAfee/getFBAPickUpFee`, params)
        .then((res) => {
          console.log("提货费", res);
          if (res.data.code == "200") {
            if (res.data.data) {
              that.THFdata.price = res.data.data.price; //价格
              that.THFdata.currency = res.data.data.currency; //币种
              that.THFdata.cnyprice = res.data.data.cnyprice; //--隐藏单价
              that.THFdata.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
              that.THFdata.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
              that.THFdata.amount = res.data.data.price;
              that.THFdata.maxKilometer = res.data.data.maxKilometer;
              that.THFdata.minKilometer = res.data.data.minKilometer;
            } else {
              that.THFdata.price = null;
              that.THFdata.currency = "";
              that.THFdata.cnyprice = null;
              that.THFdata.amount = null;
            }
          } else {
          }
        })
        .catch((res) => {});
    },
    getBoxformLIst(Sondata) {
      this.ruleform.formLIst = Sondata;
      this.Changehandle();
    },
    Changehandle(items) {
      //计算增值服务
      let File = true;
      try {
        this.ruleform.formLIst.forEach((item, index) => {
          if (item.goodsDTOList.length == 0) {
            if (items) {
              items.checked = false;
            }
            throw this.$message({
              message: `请添加${index + 1}号箱子内商品信息`,
            });
          }
          item.goodsDTOList.forEach((_item) => {
            if (_item.num == 0 || _item.num == null) {
              throw this.$message({ message: `添加的商品数量不能为0` });
            }
            if (!_item.declaredValue) {
              if (items) {
                items.checked = false;
              }
              throw this.$message({ message: `请添加商品货值` });
            }
          });
        });
      } catch (err) {
        File = false;
      }
      if (!File) return;
      let that = this;
      let params = {};
      params = {
        busFbxjobsBeforeBoxDTOList: this.ruleform.formLIst,
        countryId: this.LocahouseDTO.countryId, //国家id
        feeItemDTOList: this.formData.feeItemDTOS,
      };
      this.axios
        .post(`/FBAfee/calFBAFeeItems`, params)
        .then((res) => {
          if (res.data.code == "200") {
            that.calFBAFeeIDTOS.feeDTOList = res.data.data.feeItemDTOList;
            that.calFBAFeeIDTOS.amount = res.data.data.amount;
          } else {
          }
        })
        .catch((res) => {});
    },
    getShowcount() {
      //获取所有数据
      this.axios
        .get(`/busFbx/getOrderInfoForModify/${this.$route.query.itemWrap.nos}`)
        .then((res) => {
          console.log("count: ", res);
          if (res.data.code == "200") {
            // console.log('res.data.data.delgoodsname: ', res.data.data.delgoodsname);
            this.towarehouseid = res.data.data.recwarehouseDTO.id;
            sessionStorage.setItem(
              "towarehouseid",
              JSON.stringify(this.towarehouseid)
            );
            if (res.data.data.finaArapFbxBeforeTHFDTO) {
              let finaArapFbxBeforeTHFDTO =
                res.data.data.finaArapFbxBeforeTHFDTO;
              this.THFdata.price = finaArapFbxBeforeTHFDTO.price; //提货费价格
              this.THFdata.currency = finaArapFbxBeforeTHFDTO.currency; //币种
              this.THFdata.cnyprice = finaArapFbxBeforeTHFDTO.cnyprice; //--隐藏单价
              this.THFdata.cnycurrency = finaArapFbxBeforeTHFDTO.cnycurrency; //”CNY”--换算币种
              this.THFdata.cnyamount = finaArapFbxBeforeTHFDTO.cnyprice; //”CNY”--换算币种
              this.THFdata.amount = finaArapFbxBeforeTHFDTO.price;
              this.THFdata.maxKilometer = finaArapFbxBeforeTHFDTO.maxKilometer;
              this.THFdata.minKilometer = finaArapFbxBeforeTHFDTO.minKilometer;
            }else {
              this.THFdata.price = ""; //提货费价格
              this.THFdata.currency = ""; //币种
              this.THFdata.cnyprice = ""; //--隐藏单价
              this.THFdata.cnycurrency = ""; //”CNY”--换算币种
              this.THFdata.cnyamount = ""; //”CNY”--换算币种
              this.THFdata.amount = "";
              this.THFdata.maxKilometer = "";
              this.THFdata.minKilometer = "";
            }

            this.countLIst_S.name = res.data.data.delgoodsname;
            this.countLIst_S.tel = res.data.data.delgoodstel;
            if (res.data.data.calFBAFeeItemRespDTO) {
              this.calFBAFeeIDTOS.feeDTOList =res.data.data.calFBAFeeItemRespDTO.feeItemDTOList;
              this.calFBAFeeIDTOS.amount =res.data.data.calFBAFeeItemRespDTO.amount;
            }

            this.inwarehousetime = res.data.data.inwarehouseTime;
            this.todoorTime = res.data.data.todoordate;
            this.LocahouseDTO = res.data.data;
            this.countLIst_T = res.data.data.deliveryFbxAddressDTO; //提货信息
            if (res.data.data.finaArapFbxBeforeDTOList) {
              this.formData.feeItemDTOS =
                res.data.data.finaArapFbxBeforeDTOList;
            }

            this.ruleform.formLIst = res.data.data.busFbxjobsBeforeBoxDTOList; //箱子信息
            this.logisticsProductOrderDTO = res.data.data.logisticsProductOrderDTO;
            if (res.data.data.finaArapFbxBeforeYSFDTO) {
              this.FBATransmoney = res.data.data.finaArapFbxBeforeYSFDTO; //运输费
            }

            this.toFABck = res.data.data.recwarehouseDTO;
            this.THFdata.checked = res.data.data.isgetgoodstodoor;

            let Type = this.LocahouseDTO.recwarehouseDTO.type;
            let countryCode = this.LocahouseDTO.recwarehouseDTO.countryCode;

            if (Type == 1 && countryCode == "SA") {
              //需要校验
              this.billType = true; //显示 商铺号和追踪号
            } else if (
              (Type == 1 && countryCode != "SA") ||
              (this.toFABck.type == 1 && countryCode != "US")
            ) {
              this.billType = true;
            }
            console.log(this.billType);
          } else {
          }
        })
        .catch((res) => {});
    },
    comeback() {
      //返回上一页
      this.$router.push({ name: "FBAheader" });
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height =
          document.getElementsByClassName("wrap_R")[0].offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    this.getShowcount();
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style lang="less" scoped>
.center_wrap {
  padding-top: 30px;
  max-width: 1400px;
  min-width: 1200px;
  margin: 0 auto;
  float: left;
}
.titleSlot {
  padding: 0 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  .SlotTit {
    float: left;
    font-size: 18px;
    font-weight: bold;
    color: black;
  }
}
.wrap_l {
  float: left;
  width: 950px;
  background: #ffffff;
  padding: 0 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  max-height: 95vh;
  overflow: auto;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 950px;
}
.leftItem {
  width: 875px;
  float: left;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.3);
  border-radius: 20px;
  margin-bottom: 24px;
  overflow: hidden;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 15px 0 15px 65px;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.comeback {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaChangebill.vue